import axios from 'axios';
import {toast} from 'react-toastify';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${BACKEND_URL}/api/users`

//Register User
export const registerUser = async (userData) => {
    try {
        const response = await axios.post(`${BACKEND_URL}/api/users/register`, userData)
        if(response.statusText === "OK" ) {
            toast.success("User Created Successfully")
        }
        return response.data
    } catch (error) {
        const message = (
            error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            throw new Error(message);
    }
};

//Login User
export const loginUser = async (userData) => {
    try {
        const response = await axios.post(`${BACKEND_URL}/api/users/login`, userData)
        if(response.statusText === "OK" ) {
            toast.success("User Loggedin Successfully")
        }
        return response.data
    } catch (error) {
        const message = (
            error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
        toast.error(message);
        throw error;
    }
};

//Logout User
export const logoutUser = async () => {
    try {
        await axios.get(`${BACKEND_URL}/api/users/logout`)
        // Clear any cached axios headers/tokens
        delete axios.defaults.headers.common['Authorization'];
        return true;
    } catch (error) {
        // Even if logout fails on server, clear local state
        delete axios.defaults.headers.common['Authorization'];
        console.error('Logout error:', error);
        return false;
    }
};

//Get Login Status
export const getLoginStatus = async () => {
    try {
        const response = await axios.get(`${BACKEND_URL}/api/users/loggedin`)
        return response.data
    } catch (error) {
        // Don't clear localStorage here - let LOGOUT action handle it
        // This prevents clearing data during normal operation
        console.error('Login status check failed:', error.response?.status);
        return false;   
    }
};

//Get Users
export const getUsers = async () => {
    try {
        const response = await axios.get(`${BACKEND_URL}/api/users/getusers`)
        return response.data
    } catch (error) {
        const message = (
            error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            toast.error(message)
    }
};

//Delete User
export const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`${API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        // Don't show toast here, let the calling component handle the error message
        throw error; // Throw the full error object so we can access error.response in the component
    }
};

// Update User
export const updateUser = async (userId, userData) => {
    try {
        const response = await axios.patch(`${API_URL}/${userId}`, userData);
        if (response.status === 200) { // Checking status code directly
            toast.success("User Updated Successfully");
        }
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || error.toString();
        toast.error(message);
    }
};
